<template lang='pug'>
  r-table(
    no-remove
    v-bind='tableProps'
    @detail='submitDetail'
    :no-actions="!$can('VIEW_DETAIL_PURCHASE_ORDER')"
    )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  import { canRouteEnter } from '@/plugins/mod-can'
  import PurchaseOrderService from '@/services/api/purchase/PchPurchaseOrder'
  //
  export default {
    name: 'pch-purchase-order-list',
    components: {
      RTable,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tableProps() {
        return {
          filters: PurchaseOrderService.filters(),
          headers: PurchaseOrderService.headers(),
          service: PurchaseOrderService,
        }
      },
    },
    methods: {

      /**
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitDetail(event) {
        this.$router.push({ name: 'purchase-order-detail', params: { id: event.item.id } })
      },
    },
    beforeMount() { 
      this.setTitle('Listado histórico de órdenes de compra') 
    },
    beforeRouteEnter: canRouteEnter('VIEW_ALL_HISTORIC_PURCHASE_ORDER'),
  }
</script>
